<script lang="typescript">
    import { scale } from "svelte/transition"
    import Fa from "svelte-fa/src/fa.svelte"
    import {
        faHome,
        faBuilding,
        faCar,
        faGraduationCap,
        faCocktail,
        faBell,
        faBabyCarriage,
        faUsers,
        faMoon,
        faInfoCircle,
        faDotCircle,
        faCircle,
        faExclamation,
    } from "@fortawesome/free-solid-svg-icons"

    export let symbolCode: number
    export let showName = false
    export let breakName = false
    export let size = "1.5em"
</script>

{#key symbolCode}
    <span
    class="symbol" in:scale>
        {#if symbolCode == 1}
            <Fa icon="{faHome}" size="{size}" />
        {:else if symbolCode == 2}
            <Fa icon="{faBuilding}" size="{size}" />
        {:else if symbolCode == 3}
            <Fa icon="{faCar}" size="{size}" />
        {:else if symbolCode == 4}
            <Fa icon="{faGraduationCap}" size="{size}" />
        {:else if symbolCode == 5}
            <Fa icon="{faCocktail}" size="{size}" />
        {:else if symbolCode == 6}
            <Fa icon="{faBell}" size="{size}" />
        {:else if symbolCode == 7}
            <Fa icon="{faBabyCarriage}" size="{size}" color="#ff6666" />
        {:else if symbolCode == 8}
            <Fa icon="{faUsers}" size="{size}" />
        {:else if symbolCode == 9}
            <Fa icon="{faMoon}" size="{size}" color="orange" />
        {:else if symbolCode == 10}
            <Fa icon="{faInfoCircle}" size="{size}" color="blue" />
        {:else if symbolCode == 11}
            <Fa icon="{faDotCircle}" size="{size}" color="yellow" />
        {:else if symbolCode == 12}
            <Fa icon="{faCircle}" size="{size}" color="green" />
        {:else if symbolCode == 13}
            <Fa icon="{faExclamation}" size="{size}" color="red" />
        {:else}
            <Fa icon="{faCircle}" size="{size}" color="lightgrey" />
        {/if}
    </span>
    {#if showName}
        {#if breakName}
            <!-- <br /> -->
        {/if}
        {{
            1: "",
            2: "",
            3: "au?er Haus",
            4: "Schulung",
            5: "Party",
            6: "Erinnerung",
            7: "zur Freigabe",
            8: "Meeting",
            9: "Standby",
            10: "informativ",
            11: "in Arbeit",
            12: "erledigt",
            13: "wichtig",
            0: "---",
        }[symbolCode]}
    {/if}
{/key}
